import { FC } from 'react'
import { Input } from 'src/components/input'

type DateInputFieldVariant = 'light' | 'dark' | 'primary'

type ValidatorRef = { validationType: string; value: Record<string, unknown> }

interface DateInputFieldProps {
  value?: string | null
  disabled?: boolean
  handleResponse: (value: string) => void
  // Props below exist for interface consistency with other field types
  variant?: DateInputFieldVariant
  handleSearch?: (value: string) => void
  options?: unknown[]
  loading?: boolean
  isMultiple?: boolean
  numPad?: boolean
  questionDisplay?: string | null
  valueRef?: unknown
  validatorsRef?: ValidatorRef[]
  patternError?: string | null
  onPatternError?: (error: string | null) => void
}

const DateInputField: FC<DateInputFieldProps> = ({ handleResponse, value, disabled = false }) => {
  const inputValue = value === null || value === undefined ? '' : value
  return (
    <Input
      type="date"
      disabled={disabled}
      value={inputValue}
      onChange={(e) => {
        handleResponse(e.target.value)
      }}
    />
  )
}

export default DateInputField
